// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"1335afd2","458":"66373f36","486":"a44dce72","914":"575a2be2"}[chunkId] + ".chunk.css";
};